import PropTypes from "prop-types";
import inspectionAPI from "modules/inspections/api";
import { useAuth0 } from "@auth0/auth0-react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import AssignmentForm from "modules/inspections/components/AssignmentForm";
import { useSoftUIController } from "hooks/context";

function CreateAssignment({ selected_user, all_devices, maintenance_tags = [], inspection_data }) {

    const queryClient = useQueryClient();
    inspectionAPI.loadToken(useAuth0());

    const [controller] = useSoftUIController();
    const { selectedOrg } = controller;

    const { mutateAsync } = useMutation({
        mutationFn: ([values, onProgressUpdate]) => {
            return inspectionAPI.addNewRectification(values, onProgressUpdate)
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['getAllInspectionsForUser', selected_user.user, selectedOrg] });
        }
    });

    return <AssignmentForm {...{ selected_user, all_devices, maintenance_tags }} inspection_record={inspection_data} onSubmit={mutateAsync} />
}

CreateAssignment.propTypes = {
    selected_user: PropTypes.object.isRequired,
    all_devices: PropTypes.array.isRequired,
    maintenance_tags: PropTypes.array,
    inspection_data: PropTypes.object.isRequired
};

export default CreateAssignment;
